module.exports = __webpack_public_path__ + "assets/img/my-icon-02.58e5f24b.png";